"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Range_1 = __importDefault(require("../../../Util/Range"));
const TrainingInterface_1 = require("../../../BusinessLogicLayer/TrainingInterface");
const mostRecentStartOfWeek_1 = __importDefault(require("../../../Util/mostRecentStartOfWeek"));
const endOfWeekAfter_1 = __importDefault(require("../../../Util/endOfWeekAfter"));
const findDate_1 = __importDefault(require("../../../BusinessLogicLayer/findDate"));
class Training {
    constructor(dateTimeProvider, dateTimeModifier, dateTimeBridge, trainingRepository, dayTypeRepository) {
        this.getRange = async (customerId, userDateRange) => {
            const days = [];
            const dateRange = this.dateTimeBridge.systemRange(userDateRange);
            let date = this.dateTimeModifier.modifyDays(dateRange.from, -1);
            do {
                date = this.dateTimeModifier.modifyDays(date, 1);
                days.push(this.adaptToWeekDay(date, (await this.trainingRepository.getDate(customerId, date, "kg")), (await this.dayTypeRepository.getDayType(customerId, date))));
            } while (date !== dateRange.to);
            return {
                days,
                trainingsPerWeek: days.reduce((acc, { dayType }) => {
                    if (dayType === "TRAINING") {
                        return acc + 1;
                    }
                    return acc;
                }, 0),
            };
        };
        this.getDate = async (customerId, date, unit) => {
            const training = await this.trainingRepository.getDate(customerId, date, unit);
            return {
                date: date,
                day: this.dateTimeProvider.dayOfWeek(date),
                dayType: (await this.dayTypeRepository.getDayType(customerId, date)),
                training: training,
                weekInfo: await this.summary(customerId, date, (await this.dayTypeRepository.getDayType(customerId, date))),
            };
        };
        this.summary = async (customerId, date, dayType) => {
            const range = new Range_1.default((0, mostRecentStartOfWeek_1.default)(date), (0, endOfWeekAfter_1.default)(date));
            const week = await this.getRange(customerId, this.dateTimeBridge.userRange(range));
            const trainingDays = week.days.filter(({ dayType }) => dayType === TrainingInterface_1.WeekDayType.TRAINING_DAY);
            return {
                trainingOrdinalNumber: dayType === TrainingInterface_1.WeekDayType.TRAINING_DAY
                    ? trainingDays.indexOf((0, findDate_1.default)(date, trainingDays)) + 1
                    : null,
                trainings: trainingDays.length,
                doneTrainings: trainingDays.filter(({ isDone }) => isDone).length,
            };
        };
        this.adaptToWeekDay = (date, training, dayType) => {
            return {
                date: this.dateTimeBridge.userDate(date),
                rate: (training && training.rate) || 0,
                isDone: (training && training.isDone) || false,
                dayType,
                day: this.dateTimeProvider.dayOfWeek(date),
            };
        };
        this.dateTimeProvider = dateTimeProvider;
        this.dateTimeModifier = dateTimeModifier;
        this.dateTimeBridge = dateTimeBridge;
        this.trainingRepository = trainingRepository;
        this.dayTypeRepository = dayTypeRepository;
    }
    getTrainingsPerWeek(_customerId, _date) {
        return Promise.resolve(4);
    }
}
exports.default = Training;
//# sourceMappingURL=Training.js.map